// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__eh4Lw","col":"styles_col__3f53K"};